import { Component, OnInit } from '@angular/core';
import { ProductService, AlertService, BannersService, CategoryService, DeliveryService } from '../_services';
import { Observable } from 'rxjs/Observable';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, Validators, NgForm } from '@angular/forms';
import { Subject } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { Placeholder } from '@angular/compiler/src/i18n/i18n_ast';
import { ViewChild } from '@angular/core';
import { ElementRef } from '@angular/core';

declare var jquery: any; 
declare var $: any;
declare var alertify: any;


@Component({
  selector: 'app-del-state', 
  templateUrl: './del_states.component.html',
  styleUrls: ['./del_states.component.css']
})
export class DeliveryStateComponent implements OnInit {
  submitted: boolean;
  searchForm: FormGroup;
  constructor(private pro: ProductService, private _delivery:DeliveryService, private http: HttpClient, private toastr: ToastrService, private bannersService: CategoryService) { }
  fileToUpload: File = null;
  perPage = 10;

  loading=false;

  last_page=1;
  current_page=1;
  search_txt='';
  products$:any;

  dist_link = '/assets/state_del.xlsx'
  
  @ViewChild('downloadZipLink', { static: false }) private downloadZipLink: ElementRef;
  

  ngOnInit() {
    this.refresh('',1);

  }


  refresh(search,page){
    this._delivery.getStateDelivery(search,page,1).subscribe(data=>{
      this.products$ = data.data.data;
      this.last_page = data.data.last_page;
      this.current_page= data.data.current_page;
    },error=>{

    });
  }

  uploadExcel(e,file){
    this.fileToUpload=file[0];
  }


  uploadExcelFile(){
    if(!this.fileToUpload){
      this.toastr.error('File is required');
      return false;
    }
    this.loading=true;
    this._delivery.uploadStateExcel(this.fileToUpload).subscribe(data=>{
      if(data.status.code==0){
        this.loading=false;
        this.refresh(this.search_txt,1)
        $('[type="file"]').val('');
      }else{
        this.loading=false;
        this.toastr.error(data.status.message);
        $('[type="file"]').val('');
      }
    },error=>{

    });
  }

  deleteState(obj){
    alertify.confirm('Are you sure you want to delete this state?',()=>{
      this.loading=true;
      this._delivery.deleteState(obj._id).subscribe(data=>{
        this.loading=false;
        if(data.status.code==0){
          this.toastr.success(data.status.message);
          this.refresh(this.search_txt,1);
        }else{
          this.toastr.error(data.status.message);
        }
      },error=>{

      });
    },()=>{

    });
  }

  pageChange(page){
    this.refresh(this.search_txt,page)
  }

  search(val){
    this.search_txt = val;
    this.refresh(val,1)
  }

  download(){
    location.href=this.dist_link;
  }
}